import 'video-react/dist/video-react.css';
import { useEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import {
  ControlBar,
  CurrentTimeDisplay,
  ForwardControl,
  PlaybackRateMenuButton,
  Player,
  ReplayControl,
  TimeDivider,
  VolumeMenuButton,
} from 'video-react';
import playIcon from '../../assets/images/icon_images/playIcon.svg';
import ImgWrapper from '../img-wrapper/ImgWrapper';
import style from './GalleryItem.module.scss';

const GalleryItem = ({ url, mimeType }) => {
  const urlSrc = url.replace(/ /g, '%20').replace('http://', 'https://');
  const playerRef = useRef(null);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    if (playerRef && playerRef.current && play) playerRef.current.play();
  }, [playerRef, play]);

  return (
    <>
      {mimeType.includes('video') && (
        <Player className={style.player} ref={playerRef}>
          <source src={urlSrc} />
          {!play && (
            <button className={style.play} onClick={() => setPlay(true)}>
              <div className={style.play__icon}>
                <Svg src={playIcon} />
              </div>
            </button>
          )}
          <ControlBar>
            <ReplayControl seconds={10} order={1.1} />
            <ForwardControl seconds={30} order={1.2} />
            <CurrentTimeDisplay order={4.1} />
            <TimeDivider order={4.2} />
            <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
            <VolumeMenuButton />
          </ControlBar>
        </Player>
      )}

      {mimeType.includes('image') && <ImgWrapper imgUrl={urlSrc} alt='image' />}
    </>
  );
};

export default GalleryItem;
